import { useScrollReveal } from '@/hooks/useScrollReveal';

const promises = [
  {
    icon: 'ri-scissors-cut-line',
    title: 'Standard Cut & Grade',
    desc: 'Every product is cut, graded and packed to a published specification — so you get exactly what you paid for. No inconsistent sizing, no quality drift.',
    accent: 'text-secondary-600',
    bgColor: 'bg-secondary-50',
  },
  {
    icon: 'ri-snowy-line',
    title: 'IQF Frozen at Peak',
    desc: 'Individually Quick Frozen within hours of harvest or processing, locking in freshness, texture and nutrition. No block freezing, no freezer burn.',
    accent: 'text-accent-600',
    bgColor: 'bg-accent-50',
  },
  {
    icon: 'ri-qr-scan-line',
    title: 'Batch Traceable',
    desc: 'Scan the QR code on any pack to trace your product back to its harvest batch, processing date, and cold-chain journey. Full transparency, farm to freezer.',
    accent: 'text-primary-600',
    bgColor: 'bg-primary-50',
  },
  {
    icon: 'ri-temp-cold-line',
    title: 'Cold-Chain Verified Delivery',
    desc: 'Every order is packed in insulated boxes with temperature loggers. If the cold chain breaks at any point, we replace your order — no questions asked.',
    accent: 'text-secondary-500',
    bgColor: 'bg-secondary-50',
  },
];

export default function QualityPromise() {
  const { ref, revealed } = useScrollReveal();

  return (
    <section className="py-20 md:py-28 warm-sand-bg">
      <div ref={ref} className={`container-page scroll-reveal ${revealed ? 'revealed' : ''}`}>
        <div className="text-center mb-14 md:mb-20">
          <span className="inline-block text-xs font-semibold text-accent-600 uppercase tracking-widest mb-4">
            Our Quality Promise
          </span>
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-primary-700 mb-4">
            Why Freshhlock Retail Is Different
          </h2>
          <p className="text-foreground-500 max-w-2xl mx-auto">
            The same trust system that powers our wholesale network protects every retail order — from specification to delivery.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
          {promises.map((promise) => (
            <div
              key={promise.title}
              className="group bg-card-50 rounded-xl p-6 md:p-7 border border-card-200 shadow-sm hover:shadow-md hover:-translate-y-1 transition-all duration-300 cursor-pointer text-center card-animate"
            >
              <div className={`w-14 h-14 flex items-center justify-center rounded-xl ${promise.bgColor} ${promise.accent} mx-auto mb-5 animate-icon-float icon-hover-pop`}>
                <i className={`${promise.icon} text-xl`}></i>
              </div>
              <h4 className="font-heading text-base font-bold text-primary-700 mb-3">{promise.title}</h4>
              <p className="text-sm text-foreground-500 leading-relaxed">{promise.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}